import { trackDigitalEvent } from '@sparknz/tracking';

export function trackIneligibleWarningEvent(message: string) {
  trackDigitalEvent({
    event: 'component.view',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Component View',
            eventAction: 'component.view',
          },
        },
      ],
      component: [
        {
          componentInfo: {
            componentID: 'productDetails.changePlan.lineDetails',
            componentName: 'Change Plan Line Details',
          },
          category: {
            primaryCategory: 'productDetails',
            subCategory1: 'Change Plan',
          },
          attributes: {
            content: {
              message,
            },
          },
        },
      ],
    },
  });
}
